import { useRouter } from "next/router.js";
import { useTranslation } from "next-i18next";
import { useEffect, useState } from "react";
import { size } from "../../constants";
import { utilityLinks, workWithUsLinkProps } from "../../data/contact-info.js";
import { useWindowSize } from "../../hooks/useWindowResize.js";
import { debounce } from "../../utils/debounce.js";
import LanguageSelector from "../LanguageSelector.jsx";
import DropdownItem from "../menu/components/DropdownItem.jsx";
import Nav from "../menu/Nav.jsx";
import {
	LanguageWrapper,
	NavMobileWrapper,
	Nav as NavWrapper,
} from "../menu/styles/Topbar.styles.js";
import { Topbar } from "../menu/Topbar.jsx";

export function TopbarLanding() {
	const { t } = useTranslation();
	const { width } = useWindowSize();
	const isMobile = width <= size.laptop;
	const [scrolled, setScrolled] = useState(false);

	const router = useRouter();

	useEffect(() => {
		const handleScroll = () => {
			const offset = window.scrollY;
			if (offset > 0) {
				setScrolled(true);
			} else {
				setScrolled(false);
			}
		};

		const debouncedHandleScroll = debounce(handleScroll, 10);
		window.addEventListener("scroll", debouncedHandleScroll);

		return () => {
			window.removeEventListener("scroll", debouncedHandleScroll);
		};
	}, []);

	const moveToSection = (e, targetId) => {
		e.preventDefault();
		const header = document.getElementById("header");
		const targetElement = document.getElementById(targetId);

		if (router.pathname !== "/") {
			return router.push(`/${router?.query?.locale || "pt"}#${targetId}`);
		}

		if (header && targetElement) {
			const headerHeight = header.offsetHeight;
			const targetPosition =
				targetElement.getBoundingClientRect().top +
				window.scrollY -
				headerHeight;

			window.scrollTo({
				top: targetPosition,
				behavior: "smooth",
			});
		}
	};

	return (
		<Topbar
			showTheme={false}
			defaultTheme="dark"
			isTransparent={!scrolled && !isMobile}
		>
			<NavWrapper>
				<Nav.Dropdown title={t("header.solutions")}>
					<DropdownItem rel="follow" href="/produtos/rpa">
						{t("header.menuItems.rpa")}
					</DropdownItem>
					<DropdownItem rel="follow" href="/produtos/squad-ia">
						{t("header.menuItems.squad-ia")}
					</DropdownItem>
					<DropdownItem rel="follow" href="/produtos/hub-talentos">
						{t("header.menuItems.hub-talentos")}
					</DropdownItem>
					<DropdownItem rel="follow" href="/business-division/acceleration">
						{t("header.menuItems.acceleration")}
					</DropdownItem>
					<DropdownItem rel="follow" href="/business-division/disruption">
						{t("header.menuItems.disruption")}
					</DropdownItem>
					<DropdownItem rel="follow" href="/business-division/expansion">
						{t("header.menuItems.expansion")}
					</DropdownItem>
				</Nav.Dropdown>

				<Nav.Dropdown title={"Cases"}>
					<DropdownItem rel="follow" href="/casos/br-com">
						BR COM (RPA)
					</DropdownItem>
					<DropdownItem rel="follow" href="/casos/brinks">
						BRINKS (RPA)
					</DropdownItem>
					<DropdownItem rel="follow" href="/casos/grupo-avenida">
						GRUPO AVENIDA (RPA)
					</DropdownItem>
					<DropdownItem rel="follow" href="/casos/zignet">
						ZIGNET (RPA)
					</DropdownItem>
				</Nav.Dropdown>

				<Nav.Dropdown title={t("header.content")}>
					<DropdownItem href="/blog" rel="follow">
						{t("header.menuItems.blog")}
					</DropdownItem>
				</Nav.Dropdown>

				<NavMobileWrapper>
					<Nav.Item
						title={t("header.workWithUs")}
						href={utilityLinks.workWithUs}
						{...workWithUsLinkProps}
						isExternal
					/>
				</NavMobileWrapper>

				<NavMobileWrapper>
					<Nav.Item
						title={t("header.contact")}
						onClick={(e) => moveToSection(e, "contact-us")}
					/>
				</NavMobileWrapper>

				<NavMobileWrapper>
					<LanguageWrapper>
						<LanguageSelector showLabel={false} />
					</LanguageWrapper>
				</NavMobileWrapper>
			</NavWrapper>
		</Topbar>
	);
}
